import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

interface ValidatorOptions {
  field: string;
  value: string | number | Date;
  condition?: boolean;
}

export function requiredWhenFieldValue(options: ValidatorOptions): ValidatorFn {
  return (control: AbstractControl): ValidationErrors => {
    if (!control || !control.root || !control.parent) {
      return null;
    }

    if (options.condition !== undefined && options.condition === false) {
      return null;
    }

    const fieldValue = control.root.get(options.field).value;

    // if the options.field value matches options.value, this field is required
    if (
      fieldValue === options.value &&
      (control.value === undefined || control.value === null || control.value === '' || control.value.length === 0)
    ) {
      return { required: true };
    }

    return null;
  };
}
